import React, { useState } from "react";
import { CloseOutlined, ExclamationCircleOutlined, CalendarOutlined } from "@ant-design/icons";

const ExpiryNotification = ({ remainingDays, expiryDate, onClose }) => {
    const isCritical = remainingDays <= 7;
    const isWarning = remainingDays <= 14 && remainingDays > 7;

    const colors = isCritical
        ? {
            bg: "bg-gradient-to-r from-red-50 to-amber-50",
            icon: "text-red-500",
            title: "text-red-700",
            text: "text-red-600",
            button: "text-red-500 hover:text-red-700",
            highlight: "bg-gradient-to-r from-red-100 to-amber-100"
        }
        : isWarning
            ? {
                bg: "bg-gradient-to-r from-amber-50 to-orange-50",
                icon: "text-amber-500",
                title: "text-amber-700",
                text: "text-amber-600",
                button: "text-amber-500 hover:text-amber-700",
                highlight: "bg-gradient-to-r from-amber-100 to-orange-100"
            }
            : {
                bg: "bg-gradient-to-r from-blue-50 to-cyan-50",
                icon: "text-blue-500",
                title: "text-blue-700",
                text: "text-blue-600",
                button: "text-blue-500 hover:text-blue-700",
                highlight: "bg-gradient-to-r from-blue-100 to-cyan-100"
            };

    return (
        <div className="fixed top-10 left-0 w-full h-16 shadow-lg animate-slideDown">
            <div className={`mx-auto ${colors.bg}`}>
                <div className="mx-auto flex items-center h-full mt-6 pt-4 pb-2">
                    <div className="w-64 flex items-center h-full"></div>
                    <div className="flex justify-between w-full">
                        <div className="flex items-center">
                            <div className={`p-4 mr-3`}>

                            </div>
                            <div className={`p-2 rounded-full ${colors.highlight} mr-3`}>
                                <ExclamationCircleOutlined className={`text-lg ${colors.icon}`} />
                            </div>

                            <div>
                                <div className="flex items-center gap-2">
                                    <p className={`text-sm font-bold ${colors.title}`}>
                                        Subscription Expiring Soon!
                                    </p>
                                    {remainingDays <= 3 && (
                                        <span className="px-2 py-0.5 text-xs font-bold bg-red-500 text-white rounded-full animate-pulse">
                                            URGENT
                                        </span>
                                    )}
                                </div>

                                <div className="flex items-center gap-2 mt-0.5">
                                    <CalendarOutlined className={`text-xs ${colors.text}`} />
                                    <p className={`text-sm ${colors.text}`}>
                                        Your subscription will expire in{" "}
                                        <span className="font-bold text-base mx-1">{remainingDays}</span>
                                        {remainingDays === 1 ? "day" : "days"}
                                        {" "}on{" "}
                                        <span className="font-semibold bg-white px-2 py-0.5 rounded ml-1">
                                            {new Date(expiryDate).toLocaleDateString("en-GB", {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'
                                            })}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <div className="flex items-center gap-1">
                                <div className="w-24 h-2 bg-gray-200 rounded-full overflow-hidden mr-3">
                                    <div
                                        className={`h-full ${isCritical ? 'bg-gradient-to-r from-red-500 to-red-600' :
                                            isWarning ? 'bg-gradient-to-r from-amber-500 to-orange-500' :
                                                'bg-gradient-to-r from-blue-500 to-cyan-500'
                                            }`}
                                        style={{ width: `${Math.min(100, (30 - remainingDays) / 30 * 100)}%` }}
                                    />
                                </div>

                                <span className={`text-xs font-semibold ${colors.text}`}>
                                    {remainingDays}d left
                                </span>
                            </div>

                            <button
                                onClick={onClose}
                                className={`p-1.5 rounded-full hover:bg-white/50 transition-colors ${colors.button}`}
                                aria-label="Dismiss notification"
                            >
                                <CloseOutlined className="text-base" />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="h-1 w-full" />

                <style jsx>{`
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        .animate-slideDown {
          animation: slideDown 0.3s ease-out;
        }
      `}</style>
            </div >
        </div>
    );
};

export default ExpiryNotification;